"use client"

import { UserGroupIcon, UserIcon } from "@heroicons/react/24/outline"
import { Button } from "domains/layout/components/Button"

interface Props {
    prices: {
        individual?: number | null | undefined
        organization?: number | null | undefined
    }
}

export function PurchaseOptions({ prices }: Props) {
    const individualPrice = prices.individual
        ? new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
          }).format(prices.individual / 100)
        : prices.individual
    const organizationPrice = prices.organization
        ? new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
          }).format(prices.organization / 100)
        : prices.organization

    return (
        <div className="flex flex-col gap-8">
            {individualPrice != null && (
                <div className="flex flex-1 flex-col justify-between p-4">
                    <div className="flex-0">
                        <h2 className="text-lg font-medium">Individual Access - {individualPrice}</h2>
                        <p className="text-sm text-gray-600">Enjoy unlimited personal access to this video.</p>
                    </div>
                    <Button href="buy/individual" className="mt-4 max-h-8 w-full flex-none">
                        Buy Individual
                        <UserIcon className="ml-3 size-6" />
                    </Button>
                </div>
            )}
            {organizationPrice != null && (
                <div className="flex flex-1 flex-col p-4">
                    <div className="grow">
                        <h2 className="text-lg font-medium">Organization Access - {organizationPrice}</h2>
                        <p className="text-sm text-gray-600">Grant full access to your entire ResearchWiseAI team.</p>
                    </div>
                    <Button href="buy/organization" className="mt-4 max-h-8 w-full flex-none">
                        Buy Organization
                        <UserGroupIcon className="ml-3 size-6" />
                    </Button>
                </div>
            )}

            {individualPrice == null && organizationPrice == null && (
                <div className="flex flex-1 items-center justify-center">
                    <p className="text-lg text-gray-600">
                        Please contact
                        <a href="mailto:support@researchwiseai.com" className="text-blue-500">
                            support@researchwiseai.com
                        </a>{" "}
                        to report there are no prices available for this video.
                    </p>
                </div>
            )}
        </div>
    )
}
